// Action ID -> patient-relative URL slot. Lives client-side so the engine
// (services/workflow on the backend) stays HTTP-agnostic.

const ACTION_ROUTES: Record<string, string> = {
    'approve-records': '/design/records/approve',
    'reject-records': '/design/records/decline',
    'create-in-manufacturer': '/design/manufacturer/create',
    'submit-design-plan': '/design/manufacturer/plan/submit',
    'design-pre-approved': '/design/manufacturer/plan/pre-approve',
    'plan-received': '/design/manufacturer/plan/received',
    'approve-design-review': '/design/manufacturer/plan/approve',
    'reject-design-review': '/design/manufacturer/plan/reject',
    'hand-back-design': '/design/final-review/hand-back',
    'hand-back-dx': '/design/final-review/hand-back',
    'design-unchanged': '/design/final-review/design-unchanged',
    'ortho-approve-design': '/design/ortho-review/approve',
    'ortho-request-design-changes': '/design/ortho-review/request-changes',
    'ortho-approve-redesign': '/design/ortho-review/approve',
    'ortho-request-redesign-changes': '/design/ortho-review/request-changes',
    'submit-redesign': '/redesign/submit',
    'redesign-received': '/redesign/received',
    'approve-redesign-review': '/redesign/approve',
    'approve-redesign-skip-dx': '/redesign/approve-skip-dx',
    'reject-redesign-review': '/redesign/reject',
    'redesign-hand-back-design': '/design/final-review/hand-back',
    'redesign-hand-back-dx': '/design/final-review/hand-back',
    'redesign-unchanged': '/design/final-review/design-unchanged',
    'exit-hold': '/hold/exit',
    'submit-for-manufacturing': '/manufacturing/submit',
    'submit-post-approval-redesign': '/manufacturing/submit-redesign',
    'request-post-approval-redesign': '/manufacturing/request-redesign',
    'post-approval-redesign-received': '/manufacturing/redesign/received',
    'approve-post-approval-redesign': '/manufacturing/redesign/approve',
    'reject-post-approval-redesign': '/manufacturing/redesign/reject',
    'create-sdi': '/manufacturing/create-sdi',
    'ortho-approve-sdi': '/manufacturing/review-sdi/approve',
    'create-patient-in-dm': '/manufacturing/create-patient-in-dm',
    'aligners-shipped': '/manufacturing/aligners-shipped',
    'start-monitoring': '/in-treatment/start-monitoring',
    'refinement-needed': '/in-treatment/refinement-needed',
    'retention-needed': '/in-treatment/retention-needed',
    'vas-resolved': '/in-treatment/continue-treatment',
    'clinical-vas-resolved': '/in-treatment/hand-back-to-dm',
    'clinical-va-due': '/in-treatment/escalate-to-clinical',
    'review-approve-refinement': '/refinement/approve',
    'refuse-refinement-continue': '/refinement/refuse-continue',
    'end-treatment-start-retention': '/refinement/end-treatment',
    'approve-refinement-records': '/refinement/records/approve',
    'reject-refinement-records': '/refinement/records/decline',
    'create-refinement-in-manufacturer': '/refinement/manufacturer/create',
    'submit-refinement-for-design': '/refinement/design/submit',
    'refinement-design-pre-approved': '/refinement/design/pre-approve',
    'refinement-design-received': '/refinement/design/received',
    'approve-refinement-design-review': '/refinement/design/approve',
    'reject-refinement-design-review': '/refinement/design/reject',
    'create-refinement-rdi': '/refinement/create-rdi',
    'approve-refinement-design': '/refinement/rdi/approve',
    'request-refinement-design-revision': '/refinement/rdi/request-revision',
    'submit-refinement-for-manufacturing': '/refinement/manufacturing/submit',
    'refinement-shipped': '/refinement/manufacturing/shipped',
    'refinement-resume-treatment': '/refinement/resume-treatment',
    'retention-resume-treatment': '/retention/resume-treatment',
    'approve-retention': '/retention/approve',
    'refuse-retention-continue': '/retention/refuse-continue',
    'start-refinement-from-retention': '/retention/start-refinement',
    'approve-retention-records': '/retention/records/approve',
    'reject-retention-records': '/retention/records/reject',
    'submit-retention-to-manufacturer': '/retention/submit-to-manufacturer',
    'retainers-shipped': '/retention/mark-shipped',
    'enter-hold': '/hold/enter',
    'reactivate-case': '/terminal/reactivate'
};

export function routeForAction(action: string): string | null {
    return ACTION_ROUTES[action] ?? null;
}
